import { Injectable } from '@angular/core';
import { MwSelectorModel } from 'app/models/selector.model';
import { UserApiModel } from 'app/models/user-api.model';
import { MwStringSelectorModel } from 'app/models/string-selector.model';

@Injectable({ providedIn: 'root' })
export class MwDataMapService {
  mapUsersToSelector(users: UserApiModel[]): MwSelectorModel[] {
    return users
      .map((user) => {
        return new MwSelectorModel(
          user.userId,
          user.firstName + ' ' + user.lastName,
          user.isSupervisor
        );
      })
      .filter((selector) => selector.text)
      .sort((a, b) => a.text.localeCompare(b.text));
  }

  mapToSelectorModel<T>(
    toMap: T[],
    idSelector: (input: T) => number,
    valueSelector: (input: T) => string,
    isActiveSelector: (input: T) => boolean = () => undefined
  ): MwSelectorModel[] {
    return toMap
      .map(
        (item) =>
          new MwSelectorModel(
            idSelector(item),
            valueSelector(item),
            isActiveSelector(item)
          )
      )
      .filter((selector) => selector.text)
      .sort((a, b) => a.text.localeCompare(b.text));
  }

  mapToStringSelectorModel<T>(
    toMap: T[],
    idSelector: (input: T) => string,
    valueSelector: (input: T) => string
  ): MwStringSelectorModel[] {
    return toMap
      .map(
        (item) =>
          new MwStringSelectorModel(idSelector(item), valueSelector(item))
      )
      .filter((selector) => selector.text)
      .sort((a, b) => a.text.localeCompare(b.text));
  }
}
